module.exports = __webpack_public_path__ + "static/media/26UNRWA4.59ef7bd4.jpg";